import React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { ColorPalette } from '../../../components/config/color-palette';
import {
  adminAreaPathName,
  auditTabLabel,
  auditTabPathName,
  transactionLogTabPathName,
  transactionLogTabLabel,
  configurationLogTabPathName,
  configurationLogTabLabel,
  notificationLogTabPathName,
  notificationLogTabLabel,
  filingTabPathName,
  filingTabLabel,
} from '../admin-area-pathnames';
import { joinURL } from '../../../utilities';
import { IAdminAreaLeftNavigation } from '../admin-area';
import { AdminHeaderLink } from './admin-area-menu-links';

import { CasesMenu } from '../cases/cases-menu';
import { CitizensMenu } from '../citizens/citizens-menu';
import { CompanyMenu } from '../company/company-menu';
import { GeneralMenu } from '../general/general-menu';
import { JobAndOffersMenu } from '../job-and-offers/job-and-offers-menu';
import { OrganizationMenu } from '../organization/organization-menu';
import { TemplatesAndAppendixMenu } from '../templates-and-appendix/templates-and-appendix-menu';
import { AiMenu } from '../ai/ai-menu';
import { AuditlogMenu } from '../auditlog/auditlog-menu';
import { BillingAndCoPaymentMenu } from '../billing-and-co-payment/billing-and-co-payment-menu';
import { CitizenDeletionMenu } from '../citizen-deletion/citizen-deletion-menu';

export function AdminAreaLeftNavigation(props: IAdminAreaLeftNavigation) {
  const {
    canSeeOrganizationTab,
    canSeeGeneralTab,
    canSeeCitizensTab,
    canSeeCasesTab,
    canSeeCompanyTab,
    canSeeJobAndOffersTab,
    canSeeOfferGroups,
    canSeeForumFeedback,
    canSeeTemplatesAndAppendixTab,
    canSeeAuditTab,
    canSeeTransactionLogTab,
    canSeeConfigurationLogTab,
    canSeeFilingTab,
    canSeeCitizenDeletionTab,
    canSeeCitizenDeletionOrders,
    canSeeBillingAndCoPaymentTab,
    canSeeNotificationLogTab,
  } = props;

  return (
    <Box
      sx={{
        flexBasis: 250,
        overflow: 'auto',
        bgcolor: '#fff',
        border: `1px solid ${ColorPalette.AreaBoxBorder}`,
        borderTop: 'none',
        borderBottom: 'none',
        pb: 2,
      }}
    >
      <Typography sx={{ fontSize: 19, fontWeight: 'bolder', px: 2, mt: 2 }}>Administration</Typography>
      {canSeeOrganizationTab && <OrganizationMenu />}
      {canSeeGeneralTab && <GeneralMenu />}
      {canSeeCitizensTab && <CitizensMenu />}
      {canSeeCasesTab && <CasesMenu />}
      {canSeeCompanyTab && <CompanyMenu />}
      {canSeeJobAndOffersTab && <JobAndOffersMenu canSeeOfferGroups={canSeeOfferGroups} canSeeForumFeedback={canSeeForumFeedback} />}
      {canSeeTemplatesAndAppendixTab && <TemplatesAndAppendixMenu />}
      <AiMenu />
      {canSeeBillingAndCoPaymentTab && <BillingAndCoPaymentMenu />}
      {canSeeAuditTab && <AuditlogMenu />}
      {canSeeTransactionLogTab && <AdminHeaderLink to={joinURL('/', adminAreaPathName, transactionLogTabPathName)}>{transactionLogTabLabel}</AdminHeaderLink>}
      {canSeeFilingTab && <AdminHeaderLink to={joinURL('/', adminAreaPathName, filingTabPathName)}>{filingTabLabel}</AdminHeaderLink>}
      {canSeeConfigurationLogTab && <AdminHeaderLink to={joinURL('/', adminAreaPathName, configurationLogTabPathName)}>{configurationLogTabLabel}</AdminHeaderLink>}
      {canSeeNotificationLogTab && <AdminHeaderLink to={joinURL('/', adminAreaPathName, notificationLogTabPathName)}>{notificationLogTabLabel}</AdminHeaderLink>}
      {(canSeeCitizenDeletionTab || canSeeCitizenDeletionOrders) && (
        <CitizenDeletionMenu canSeeSingleDeletion={canSeeCitizenDeletionTab} canSeeOrders={canSeeCitizenDeletionOrders} />
      )}
    </Box>
  );
}
